import { config } from './cognitoConfig'
import { logout } from './cognitoAuth'

// Variable para evitar múltiples redirecciones simultáneas
let isRedirecting = false

/**
 * Detecta cuando el token expira en el microfrontend y redirige al login
 */
export function setupMicrofrontendListener() {
  window.addEventListener('message', (event) => {
    // Validación básica del mensaje
    if (!event || !event.data || typeof event.data !== 'object') {
      return
    }

    // Verificar origen del mensaje - permitir localhost y URLs configuradas
    const allowedOrigins = [
      process.env.VUE_APP_MICROFRONTEND_BOARD,
      process.env.VUE_APP_URL_FRONTEND,
      'http://localhost:5173', // microfrontend-board en desarrollo
      'http://localhost:5174'  // microfrontend-delivery en desarrollo
    ].filter(Boolean)

    const isOriginAllowed = allowedOrigins.some(origin => {
      const cleanOrigin = origin.replace('http://', '').replace('https://', '').split('/')[0]
      return event.origin.includes(cleanOrigin)
    })

    if (!isOriginAllowed) {
      return // Ignorar mensajes de orígenes no autorizados
    }

    const messageType = event.data.type
    const messageSource = event.data.source

    // Filtrar mensajes que no necesitamos procesar
    const ignoredTypes = ['webpackOk', 'webpackWarnings', 'webpackErrors', undefined, null, '']
    if (ignoredTypes.includes(messageType)) {
      return
    }

    // Manejar el evento AUTH_TOKEN_EXPIRED del microfrontend
    if (messageType === 'AUTH_TOKEN_EXPIRED') {
      handleTokenExpiredFromMicrofrontend(event)
      return
    }

    // Log otros eventos para debugging (solo en desarrollo)
    if (process.env.NODE_ENV === 'development') {
      console.log('📨 Mensaje de microfrontend:', {
        type: messageType,
        source: messageSource,
        origin: event.origin
      })
    }
  })

}

/**
 * Maneja el evento de token expirado proveniente del microfrontend
 */
function handleTokenExpiredFromMicrofrontend(event) {
  // Si ya estamos redirigiendo, no hacer nada más
  if (isRedirecting) {
    return
  }

  const source = event.data.source || 'microfrontend'
  
  console.error(`❌ Token expirado detectado en ${source}`)
  console.log('🔐 Redirigiendo a login de Cognito...')

  // Marcar que estamos redirigiendo
  isRedirecting = true

  // Limpiar localStorage (tokens, usuario, etc.)
  logout()

  // Opcional: Guardar la ruta actual para redirección después del login
  const currentPath = window.location.pathname
  if (currentPath && currentPath !== '/' && !currentPath.includes('/login')) {
    sessionStorage.setItem('redirectAfterLogin', currentPath)
  }

  // Redirigir a Cognito login después de un breve delay
  setTimeout(() => {
    const loginUrl = config.getLoginUrl()
    window.location.href = loginUrl
  }, 500)

  // Resetear flag después de 3 segundos (por si algo falla)
  setTimeout(() => {
    isRedirecting = false
  }, 3000)
}

/**
 * Función auxiliar para que componentes puedan verificar si hay redirección en curso
 */
export function isRedirectingToLogin() {
  return isRedirecting
}
